import { createFileRoute } from '@tanstack/react-router'
import { InventoryManagement } from 'pages/inventoryManagement/InventoryManagement'

export const Route = createFileRoute('/inventory')({
  component: InventoryManagement,
  staticData: {
    title: 'Inventory',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})
